import envInstants from "libs/configs/env";
import HttpClient from "libs/utils/HttpClient";
class OCRService {
  isInit = false;
  httpClient = HttpClient;

  _init() {
    if (!this.isInit) {
      this.isInit = true;
      this.httpClient = HttpClient.getNewInstant();
      this.httpClient.setBaseUrl(envInstants.getConfig().baseOCRUrl);
    }
  }

  read = async (file) => {
    this._init();

    try {
      console.log(file);
      const formData = new FormData();
      formData.append("file", file);

      const response = await this.httpClient.post(
        "/api/ocr/ReadOCR",
        formData,
        true
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };
}

export default new OCRService();
